import { createRouter, createWebHistory } from "vue-router";
import IndexLandingPage from "@/pages/IndexLandingPage.vue";
import IndexHomePage from "@/pages/IndexHomePage.vue";
import IndexLOARequestPage from "@/pages/IndexLOARequestPage.vue";
import IndexOnboardPage from "@/pages/IndexOnboardPage.vue";
import IndexOnboardIMSPage from "@/pages/IndexOnboardingIMSPage.vue";
import IndexTransactionHistoryPage from "@/pages/IndexTransactionPage.vue";
import IndexTransactionHistoryDetailPage from "@/pages/IndexTransactionDetailPage.vue";
import IndexPolicyDetailPage from "@/pages/IndexPolicyDetailPage.vue";
import IndexBirthdateForm from "@/pages/IndexBirthdateUpdate.vue";
import IndexLearnMorePage from "@/pages/IndexLearnMore.vue";
import IndexInformationCenter from "@/pages/support-center/IndexInformationCenter.vue";
import IndexInformationCenterAvailment from "@/pages/support-center/IndexInformationAvailmentProcess.vue";
import IndexInformationCenterFAQ from "@/pages/support-center/IndexInformationFAQ.vue";
import IndexInformationCenterVideos from "@/pages/support-center/IndexInformationVideoGuide.vue";

import IndexContactUsPage from "@/pages/IndexContactPage.vue";

import IndexPaymentCenterAuth from "@/pages/payment-center/IndexPaymentCenterAuth.vue";
import IndexPaymentCenterHome from "@/pages/payment-center/IndexPaymentCenterHome.vue";
import IndexPaymentCenterPaymentMode from "@/pages/payment-center/IndexPaymentCenterPaymentMode.vue";
import IndexPaymentCenterPaymentCheckout from "@/pages/payment-center/IndexPaymentCenterCheckout.vue";
import IndexPaymentCenterPaymentConfirmation from "@/pages/payment-center/IndexPaymentCenterPaymentConfirmation.vue";
import IndexPaymentCenterPaymentSuccess from "@/pages/payment-center/IndexPaymentCenterPaymentSuccess.vue";
import IndexPaymentCenterPaymentTracking from "@/pages/payment-center/IndexPaymentCenterTracking.vue";
import IndexPaymentCenterPaymentInstallment from "@/pages/payment-center/IndexPaymentCenterPaymentInstallment.vue";
import IndexPaymentCenterPaymentInstallmentCheckout from "@/pages/payment-center/IndexPaymentCenterInstallmentCheckout.vue";

const routes = [
  {
    path: "/payment/center/auth/:id",
    name: "payment-center",
    component: IndexPaymentCenterAuth,
    meta: {
      title: "Welcome to Payment Center",
      layout: "General",
      requiresAuth: false,
      liveChat: false,
    },
  },
  {
    path: "/payment/center/home",
    name: "payment-center-home",
    component: IndexPaymentCenterHome,
    meta: {
      title: "Welcome to Payment Center",
      layout: "PaymentCenter",
      requiresAuth: false,
      liveChat: false,
    },
  },

  {
    path: "/payment/center/payment-mode",
    name: "payment-center-payment-mode",
    component: IndexPaymentCenterPaymentMode,
    meta: {
      title: "Welcome to Payment Center",
      layout: "PaymentCenter",
      requiresAuth: false,
      liveChat: false,
    },
  },

  {
    path: "/payment/center/payment-checkout",
    name: "payment-center-payment-checkout",
    component: IndexPaymentCenterPaymentCheckout,
    meta: {
      title: "Welcome to Payment Center",
      layout: "PaymentCenter",
      requiresAuth: false,
      liveChat: false,
    },
  },

  {
    path: "/payment/center/payment-confirmation/:id",
    name: "payment-center-payment-confirmation",
    component: IndexPaymentCenterPaymentConfirmation,
    meta: {
      title: "Welcome to Payment Center",
      layout: "General",
      requiresAuth: false,
      liveChat: false,
    },
  },
  {
    path: "/payment/center/payment-confirmation/success/:id",
    name: "payment-center-payment-confirmation-success",
    component: IndexPaymentCenterPaymentSuccess,
    meta: {
      title: "Welcome to Payment Center",
      layout: "General",
      requiresAuth: false,
      liveChat: false,
    },
  },
  {
    path: "/payment/center/tracking/:id",
    name: "payment-center-payment-tracking",
    component: IndexPaymentCenterPaymentTracking,
    meta: {
      title: "Welcome to Payment Center",
      layout: "PaymentCenter",
      requiresAuth: false,
      liveChat: false,
    },
  },
  {
    path: "/payment/center/payment/installment",
    name: "payment-center-payment-installment",
    component: IndexPaymentCenterPaymentInstallment,
    meta: {
      title: "Welcome to Payment Center",
      layout: "PaymentCenter",
      requiresAuth: false,
      liveChat: false,
    },
  },
  {
    path: "/payment/center/installment/payment-checkout",
    name: "payment-center-payment-installment-checkout",
    component: IndexPaymentCenterPaymentInstallmentCheckout,
    meta: {
      title: "Welcome to Payment Center",
      layout: "PaymentCenter",
      requiresAuth: false,
      liveChat: false,
    },
  },
  {
    path: "/",
    name: "onboard",
    component: IndexOnboardPage,
    meta: {
      title: "Welcome to AMAP",
      layout: "General",
      requiresAuth: false,
      liveChat: false,
    },
  },
  {
    path: "/ims",
    name: "onboardIMS",
    component: IndexOnboardIMSPage,
    meta: {
      title: "Welcome to AMAP",
      layout: "General",
      requiresAuth: false,
      liveChat: false,
    },
  },
  {
    path: "/auth",
    name: "auth",
    component: IndexLandingPage,
    meta: {
      title: "Login",
      layout: "General",
      requiresAuth: false,
      liveChat: false,
    },
  },
  {
    path: "/auth/home",
    name: "home",
    component: IndexHomePage,
    meta: {
      title: "Home",
      layout: "Account",
      requiresAuth: true,
      liveChat: true,
    },
  },
  {
    path: "/auth/request/loa",
    name: "RequestLOA",
    component: IndexLOARequestPage,
    meta: {
      title: "Request LOA",
      layout: "Account",
      requiresAuth: true,
      liveChat: true,
    },
  },
  {
    path: "/auth/request/loa/transaction",
    name: "Transaction",
    component: IndexTransactionHistoryPage,
    meta: {
      title: "Transaction History",
      layout: "Account",
      requiresAuth: true,
      liveChat: true,
    },
  },
  {
    path: "/auth/request/loa/transaction/detail/:id",
    name: "TransactionPerApproval",
    component: IndexTransactionHistoryDetailPage,
    meta: {
      title: "Transaction Details",
      layout: "Account",
      requiresAuth: true,
      liveChat: true,
    },
  },
  {
    path: "/auth/policy/detail",
    name: "PolicyDetails",
    component: IndexPolicyDetailPage,
    meta: {
      title: "Policy Details",
      layout: "Account",
      requiresAuth: true,
      liveChat: true,
    },
  },
  {
    path: "/amap/birthdate/form/:id",
    name: "BirthdateForm",
    component: IndexBirthdateForm,
    meta: {
      title: "Birthdate Form",
      layout: "General",
      requiresAuth: false,
      liveChat: false,
    },
  },
  {
    path: "/amap/learnmore",
    name: "learnmore",
    component: IndexLearnMorePage,
    meta: {
      title: "Learn More",
      layout: "General",
      requiresAuth: false,
      liveChat: false,
    },
  },
  {
    path: "/auth/support-center/information",
    name: "InformationCenter",
    component: IndexInformationCenter,
    meta: {
      title: "Information Center",
      layout: "Account",
      requiresAuth: true,
      liveChat: true,
    },
  },
  {
    path: "/auth/support-center/information/availment-process",
    name: "InformationCenterAvailment",
    component: IndexInformationCenterAvailment,
    meta: {
      title: "Availment Process",
      layout: "Account",
      requiresAuth: true,
      liveChat: true,
    },
  },
  {
    path: "/auth/support-center/information/faq",
    name: "InformationCenterFAQ",
    component: IndexInformationCenterFAQ,
    meta: {
      title: "FAQ",
      layout: "Account",
      requiresAuth: true,
      liveChat: true,
    },
  },
  {
    path: "/auth/support-center/information/videos",
    name: "InformationCenterVideo",
    component: IndexInformationCenterVideos,
    meta: {
      title: "Video Guides",
      layout: "Account",
      requiresAuth: true,
      liveChat: true,
    },
  },
  {
    path: "/auth/contact/detail",
    name: "ContactUs",
    component: IndexContactUsPage,
    meta: {
      title: "Contact Us",
      layout: "Account",
      requiresAuth: true,
      liveChat: true,
    },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  document.title = `IWC Payment Channel`;

  // ✅ If acct=ims → redirect to external site
  if (to.query.acct === "ims") {
    window.location.href = "https://ims-anec-benefits.ims.com.ph/public/";
    return;
  }

  const token = localStorage.getItem(process.env.VUE_APP_AUTH_TOKEN);
  const isAuthenticate = !!token;

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!isAuthenticate) {
      next({ path: "/" });
    } else {
      next();
    }
  } else {
    if ((to.name === "auth" || to.name === "onboard") && isAuthenticate) {
      next({ path: "/auth/home" });
    } else {
      next();
    }
  }
});
export default router;
